export const APP_ACTIONS = {
  SET_PRELOADING: 'setPreloading',
  SET_DISCLAIMER_TEXT: 'setDisclaimerText',
  SET_SIDEBAR_STATE: 'setSidebarState',
  SET_BREADCRUMBS: 'setBreadcrumbs',
};

export const APP_GETTERS = {
  SIDEBAR_STATE: 'sidebarState',
  PRELOADING: 'preloading',
  DISCLAIMER_TEXT: 'disclaimerText',
  BREADCRUMBS: 'breadcrumbs',
};

const APP_MUTATIONS = {
  CACHE_PRELOADING: 'cachePreloading',
  SET_DISCLAIMER_TEXT: 'setDisclaimerText',
  SET_SIDEBAR_STATE: 'setSidebarState',
  SET_BREADCRUMBS: 'setBreadcrumbs',
};

export default {
  namespaced: true,
  state: {
    sidebarState: false,
    preloading: true,
    disclaimerText: false,
    breadcrumbs: [],
  },
  getters: {
    [APP_GETTERS.SIDEBAR_STATE]: state => state.sidebarState,
    [APP_GETTERS.PRELOADING]: state => state.preloading,
    [APP_GETTERS.DISCLAIMER_TEXT]: state => state.disclaimerText,
    [APP_GETTERS.BREADCRUMBS]: state => state.breadcrumbs,
  },
  actions: {
    [APP_ACTIONS.SET_PRELOADING]: async ({ commit }, flag) => {
      commit(APP_MUTATIONS.CACHE_PRELOADING, flag);
    },
    [APP_ACTIONS.SET_DISCLAIMER_TEXT]: async ({commit}, flag) => {
      commit(APP_MUTATIONS.SET_DISCLAIMER_TEXT, flag);
    },
    [APP_ACTIONS.SET_SIDEBAR_STATE]: async ({commit}, condition) => {
      commit(APP_MUTATIONS.SET_SIDEBAR_STATE ,condition);
    },
    [APP_ACTIONS.SET_BREADCRUMBS]: async ({commit}, breadcrumbs) => {
      commit(APP_MUTATIONS.SET_BREADCRUMBS, breadcrumbs);
    }
  },
  mutations: {
    [APP_MUTATIONS.CACHE_PRELOADING]: (state, status) => {
      state.preloading = status;
    },
    [APP_MUTATIONS.SET_DISCLAIMER_TEXT]: (state, status) => {
      state.disclaimerText = status;
    },
    [APP_MUTATIONS.SET_SIDEBAR_STATE]: (state, condition) => {
      state.sidebarState = condition;
    },
    [APP_MUTATIONS.SET_BREADCRUMBS]: (state, breadcrumbs) => {
      state.breadcrumbs = breadcrumbs;
    }
  },
};
